const TTL_MS = 5 * 60 * 1000; // 5 minutes

export function getFresh(state) {
  return (id) => {
    const e = state.byId[id];
    if (!e) return null;
    return Date.now() - e.ts < TTL_MS ? e.item : null;
  };
}

export function getStale(state) {
  return (id) => state.byId[id]?.item || null;
}
